'use client';

import { ENGAGEMENT_EVENTS } from '@repo/analytics';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { trackEvent } from '../track-event';

const DEPTH_BUCKETS = [25, 50, 75, 100] as const;

function getScrollPercent(): number {
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  if (docHeight <= 0) {
    return 0;
  }
  return (window.scrollY / docHeight) * 100;
}

export function useScrollDepthTracking(): void {
  const pathname = usePathname();
  const firedRef = useRef<Set<number>>(new Set());

  useEffect(() => {
    firedRef.current = new Set();
    if (typeof window === 'undefined') {
      return;
    }
    const handler = (): void => {
      const percent = getScrollPercent();
      for (const bucket of DEPTH_BUCKETS) {
        if (percent >= bucket && !firedRef.current.has(bucket)) {
          firedRef.current.add(bucket);
          trackEvent(ENGAGEMENT_EVENTS.scrollDepth, { depth: bucket, path: pathname ?? '' });
        }
      }
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [pathname]);
}
